<template>
  <div class="contentContainer">
    <div class="proTitle">电子签约保全证书</div>
    <div class="proId">证书编号：{{data.certificateCode?data.certificateCode:""}}</div>
    <div class="proDscp">本证书由司法联盟链legalXchain签发，证明文件（电子数据）自电子签约发起至签署完成，已经存在且内容保持完整，未被修改。</div>
    <div class="proIdList proIdNumber">
      <div class="item">
        <div class="label">合同指纹HASH：</div>
        <div class="content">{{data.fileHash?data.fileHash:''}}</div>
      </div>
      <div class="item">
        <div class="label">区块链保全ID：</div>
        <div class="content">{{data.txId?data.txId:""}}</div>
      </div>
    </div>
    <div class="proIdList formItem">
      <div class="item">
        <div class="label">合同名称：</div>
        <div class="content">{{data.contract.name?data.contract.name:""}}</div>
      </div>
      <div class="item">
        <div class="label">签署截止日期：</div>
        <div class="content">{{data.contract.signDeadlineDate.slice(0,10)}}</div>
      </div>
      <div class="item" v-if="data.contract.startDate && data.contract.endDate">
        <div class="label">合同有效期限：</div>
        <div
          class="content"
        >{{data.contract.startDate.slice(0,10) + ' 至 ' + data.contract.endDate.slice(0,10)}}</div>
      </div>
      <div class="item" v-else>
        <div class="label">合同有效期限：</div>
        <div
          class="content"
        >{{"" +' - ' + ""}}</div>
      </div>
      <div class="item">
        <div class="label">发起方：</div>
        <div class="content">{{data.contractUser.name?data.contractUser.name:""}}</div>
      </div>
      <div class="item">
        <div class="label">发起签约时间：</div>
        <div class="content">{{data.contract.signStartTime?data.contract.signStartTime:""}}</div>
      </div>
      <div class="item">
        <div class="label">签署方：</div>
        <div class="content">{{getSignUser(data.signatoryList?data.signatoryList:"")}}</div>
      </div>
      <div class="item">
        <div class="label">签署完成时间：</div>
        <div class="content">{{data.contract.signFinishTime}}</div>
      </div>
      <div class="item">
        <div class="label">签署平台：</div>
        <div class="content">广州公证处区块链赋强公证系统</div>
      </div>
      <div class="item">
        <div class="label">顺序签署：</div>
        <div class="content" v-if="data.contract.orderType==1">是</div>
        <div class="content" v-if="data.contract.orderType==0">否</div>
      </div>
      <div class="item">
        <div class="label">时间戳：</div>
        <div class="content">国家授时中心北斗卫星授时</div>
      </div>
      <div class="item">
        <div class="label">证书签发机构：</div>
        <div class="content">广东省广州市广州公证处</div>
      </div>
      <div class="item">
        <div class="label">文件大小：</div>
        <div class="content">{{data.fileSize?data.fileSize:""}}</div>
      </div>
      <div class="item">
        <div class="label">文件格式：</div>
        <div class="content">{{ data.fileType }}</div>
      </div>
    </div>
    <div class="bottomDetailPosition">
      <div class="bottomDetail">
        <div class="qrcodeBox">
          <vue-qr id="qrcode" :text="codeValue"></vue-qr>
          <p class="qrcodeDscp">手机端<br>扫码查看</p>
        </div>
        <div class="sealPower">
          <div class="seal-item"></div>
          <div class="seal-title-h1">证书签发机构</div>
          <div class="seal-title-h2">司法联盟链</div>
        </div>
        <div class="sealFq">
          <div class="seal-item"></div>
          <div class="seal-title-h1">证书签发节点</div>
          <div class="seal-title-h2">广东省广州市广州公证处</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueQr from "vue-qr";//二维码插件
import config from "@lib/config.js";
export default {
  props: ["data"],
  data() {
    return {
      codeValue: `${config.mobileSignUrl}/m/signComplete/?id=${
        this.$route.query.id
      }&fileId=${this.$route.query.fileId}&type=1&notaryApplyId=${this.$route.query.notaryApplyId}`
    };
  },
  mounted() {
    console.log(this.data,"cretInfo");
    console.log(this.codeValue);
    // window.onresize=function(){
    //   alert(window.innerWidth)
    // }
  },
  components: {
    VueQr
  },
  methods: {
    getSignUser(data) {
      let temp = "";
      if (data && data.length) {
        data.forEach(element => {
          temp += element.name + "  ";
        });
      }
      return temp;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.contentContainer {
  width: 100%;
  height: 730px;
  box-sizing: border-box;
  background: url(./../../assets/images/signCertificate/Group_bg.png);
  background-size: 100% 100%;
  padding: 10px 30px 20px 30px;
  position: relative;
  //.proFlag {
  //  width: 140px;
  //  height: 60px;
  //  margin: 0 auto;
  //  margin-bottom: 20px;
  //  background: url(./../../assets/images/signCertificate/logo02_img.png);
  //  background-size: 100%;
  //}
  .proTitle {
    font-family: PingFangSC-Medium;
    font-size: 13px;
    margin: 14px auto;
    background: url(./../../assets/images/signCertificate/Group_title.png) no-repeat;
    background-size: cover;
    width: 200px;
    height: 36px;
    line-height: 26px;
    color: #fff;
    text-align: center;
  }
  .proId {
    font-size: 12px;
    color: #464646;
    text-align: center;
    line-height: 12px;
    margin-bottom: 6px;
  }
  .proDscp {
    font-size: 11px;
    color: #787878;
    text-align: justify;
    line-height: 16px;
    text-indent: 2em;
    margin-bottom: 12px;
  }
  .proIdList {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 10px;
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #646464;
    line-height: 12px;
    .item {
      display: flex;
      justify-content: space-around;
      .label {
        width: 94px;
        text-align: right;
        font-size: 11px;
        word-break: break-all;
        line-height: 11px;
        color: #505050;
      }
      .content {
        word-wrap: break-word;
        width: 237px;
        text-align: left;
        font-size: 12px;
        line-height: 14px;
        color: #646464;
      }
    }
  }
  .formItem {
    background: none;
    height: auto;
    position: relative;
    .item {
      margin-bottom: 6px;

      &:last-child {
        margin-bottom: 0;
      }

      .label {
        line-height: 11px;
      }
      .content {
        font-size: 12px;
        line-height: 12px;
        margin-top: 0px;
      }
    }
  }
  .proIdNumber {
    background: #FAFAFA;

    .item {
      margin-bottom: 14px;
      display: flex;
      flex-direction: row;
      align-items: center;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .bottomDetail {
    width: 100%;
    height: 63px;
    display: flex;

    .sealPower,
    .sealFq {
      position: relative;
      text-align: center;
      display: flex;
      flex-direction: column;
      flex-shrink: 0;

      .seal-item {
        height: 56px;
        width: 56px;
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -28px;
      }

      .seal-title-h1 {
        color: #505050;
        font-size: 10px;
        font-weight: bolder;
        margin-bottom: 8px;
        margin-top: 20px;
      }

      .seal-title-h2 {
        color: #A0A0A0;
        font-size: 10px;
      }
    }

    .sealPower {
      margin-left: 55px;
      .seal-item {
        background: url(./../../assets/images/signCertificate/chapter02_img.png);
        background-size: cover;
      }
    }
    .sealFq {
      margin-left: 10px;
      .seal-item {
        background: url(./../../assets/images/signCertificate/seal_fq.png);
        background-size: cover;
      }
    }
    //.sealFq {
    //  width: 56px;
    //  height: 56px;
    //  background: url(./../../assets/images/signCertificate/chapter02_img.png);
    //  background-size: cover;
    //}
    .qrcodeBox {
      display: flex;
      flex-direction: row;
      width: 108px;
      align-items: center;
      flex-shrink: 0;
    }
    #qrcode {
      //width: 60px;
      //height: 60px;
      // background: url(./../../assets/images/signCertificate/code02_img.png);
      // background-size: 80px 80px;
      //margin: 0 auto;
      //margin-bottom: 10px;
      img {
        width: 60px;
        height: 60px;
      }
    }
    .qrcodeDscp {
      font-size: 8px;
      color: #505050;
      text-align: left;
      line-height: 14px;
    }
  }
  .bottomDetailPosition{
    position: absolute;
    bottom: 129px;
  }
}
// @media screen and (min-width: 1690px) {
//     .contentContainer .bottomDetail{
//       margin-top:23 !important;
//     }
// }

</style>
